export const isArray = (value) => Array.isArray(value);
export const isPopulatedArray = (value, length = 1) => isArray(value) && value.length >= length;
export const shuffle = (array) => {
    let currentIndex = array.length;
    let randomIndex;
    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex],
        ];
    }
    return array;
};
//# sourceMappingURL=array.js.map